var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Layout',{attrs:{"type":"REVENUE","isRevenue":"true","pageTitle":_vm.$t('menu.revenueDetails')}},[_c('RevenueData'),_c('LastSenvenRenvue'),_c('FAQ')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }